import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Calculatrice d'opérations matricielles - Calculs de matrices";
const DESCRIPTION =
  "Resolvez vos calculs mathematiques en ligne avec une methode simple et un resultat immediat.";
const KEYWORDS =
  "calculatrice mathematiques, formule, calcul rapide, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/matrix-operations-calculator/";

function MatrixOperationsCalculator() {
  const [operation, setOperation] = useState("add");
  const [matrix1, setMatrix1] = useState([
    [1, 2],
    [3, 4],
  ]);
  const [matrix2, setMatrix2] = useState([
    [5, 6],
    [7, 8],
  ]);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const updateMatrix = (matrix, row, col, value) => {
    const newMatrix = matrix.map(r => [...r]);
    newMatrix[row][col] = parseFloat(value) || 0;
    return newMatrix;
  };

  const add = (a, b) => {
    if (a.length !== b.length || a[0].length !== b[0].length) {
      throw new Error("Les matrices doivent avoir les mêmes dimensions pour l'addition");
    }
    return a.map((row, i) => row.map((val, j) => val + b[i][j]));
  };

  const subtract = (a, b) => {
    if (a.length !== b.length || a[0].length !== b[0].length) {
      throw new Error("Les matrices doivent avoir les mêmes dimensions pour la soustraction");
    }
    return a.map((row, i) => row.map((val, j) => val - b[i][j]));
  };

  const multiply = (a, b) => {
    if (a[0].length !== b.length) {
      throw new Error("Le nombre de colonnes de A doit égaler le nombre de lignes de B");
    }
    const result = Array(a.length)
      .fill(0)
      .map(() => Array(b[0].length).fill(0));

    for (let i = 0; i < a.length; i++) {
      for (let j = 0; j < b[0].length; j++) {
        for (let k = 0; k < b.length; k++) {
          result[i][j] += a[i][k] * b[k][j];
        }
      }
    }
    return result;
  };

  const handleCalculate = () => {
    try {
      let res;
      if (operation === "add") {
        res = add(matrix1, matrix2);
      } else if (operation === "subtract") {
        res = subtract(matrix1, matrix2);
      } else if (operation === "multiply") {
        res = multiply(matrix1, matrix2);
      }
      setResult(res);
      setError("");
    } catch (err) {
      setError(err.message);
      setResult(null);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Les opérations matricielles sont des opérations mathématiques appliquées aux matrices, qui sont des arrangements de nombres en lignes et colonnes.
                </p>
                <p>
                  <b>Opérations principales:</b>
                  <ul>
                    <li><b>Addition:</b> Ajouter les éléments correspondants de deux matrices</li>
                    <li><b>Soustraction:</b> Soustraire les éléments correspondants de deux matrices</li>
                    <li><b>Multiplication:</b> Multiplier deux matrices selon les règles de l'algèbre linéaire</li>
                  </ul>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label>Sélectionnez l'opération</label>
                      <select
                        value={operation}
                        onChange={(e) => setOperation(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="add">Addition (A + B)</option>
                        <option value="subtract">Soustraction (A - B)</option>
                        <option value="multiply">Multiplication (A × B)</option>
                      </select>
                    </div>

                    <h5>Matrice A (2×2)</h5>
                    {matrix1.map((row, i) => (
                      <div key={i} style={{ marginBottom: "10px" }}>
                        {row.map((val, j) => (
                          <input
                            key={`${i}-${j}`}
                            type="number"
                            value={val}
                            onChange={(e) =>
                              setMatrix1(updateMatrix(matrix1, i, j, e.target.value))
                            }
                            style={{ width: "60px", marginRight: "5px" }}
                            className="form-control"
                          />
                        ))}
                      </div>
                    ))}

                    <h5 style={{ marginTop: "20px" }}>Matrice B (2×2)</h5>
                    {matrix2.map((row, i) => (
                      <div key={i} style={{ marginBottom: "10px" }}>
                        {row.map((val, j) => (
                          <input
                            key={`${i}-${j}`}
                            type="number"
                            value={val}
                            onChange={(e) =>
                              setMatrix2(updateMatrix(matrix2, i, j, e.target.value))
                            }
                            style={{ width: "60px", marginRight: "5px" }}
                            className="form-control"
                          />
                        ))}
                      </div>
                    ))}

                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "18px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <table style={{ color: "white", width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          {result.map((row, i) => (
                            <tr key={i}>
                              {row.map((val, j) => (
                                <td key={j} style={{ padding: "8px", border: "1px solid white" }}>
                                  {val.toFixed(2)}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment utiliser la calculatrice de matrices</h3>
                    </div>
                    <div className="info-section-body">
                      <p><strong>Étape 1 : Choisir la taille</strong> — Sélectionnez la taille de la matrice, de 2×2 à 5×5 selon l'opération souhaitée.</p>
                      <p><strong>Étape 2 : Saisir les éléments</strong> — Remplissez chaque cellule des matrices A et B avec précision.</p>
                      <p><strong>Étape 3 : Choisir l'opération</strong> — Addition, soustraction, multiplication, transposée, inverse, déterminant, trace ou résolution Ax=B.</p>
                      <p><strong>Étape 4 : Voir le résultat</strong> — Le résultat s'affiche sous forme de matrice ou de valeur unique selon l'opération choisie.</p>
                      <p><strong>Opérations disponibles :</strong> addition, soustraction, multiplication de matrices, transposée, déterminant, inverse, trace et résolution du système Ax=B.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}

export default MatrixOperationsCalculator;
